/** @format */

import {styled} from '@mui/material/styles';
import {TableRow} from '@mui/material';

import {TableVariant} from '../../types';

export const StyledTableFooterRow = styled(TableRow, {
  shouldForwardProp: prop => prop !== 'variant',
})<{variant?: TableVariant}>(({theme, variant = 'dark'}) => {
  const semanticPalette =
    variant === 'light' ? theme.palette.semantic_light : theme.palette.semantic_dark;

  return {
    // Тотал-строка визуально отличима по верхнему border + font-weight (UI-1).
    // Фон — surface1 (тот же, что у обычных строк), без отдельной заливки.
    borderTop: `1px solid ${semanticPalette?.surface.surface2}`,
    backgroundColor: semanticPalette?.surface.surface1,

    // Полужирный шрифт ячеек тотал-строки (UI-1, признак №2). Покрывает оба
    // случая: текст напрямую в td и текст внутри Typography.
    '.MuiTableCell-root, .MuiTableCell-root .MuiTypography-root': {
      fontWeight: 600,
    },

    // Без hover — тотал-строка не должна визуально конкурировать с hover
    // обычных строк (UI-1, P2-new-4).
    '&:hover': {
      backgroundColor: semanticPalette?.surface.surface1,
    },
  };
});
